import { useIsMobile } from '@repo/lib';
import {
  AppBreadcrumb,
  SIDEBAR_WIDTH,
  SidebarInset,
  SidebarTrigger,
  useSidebar,
} from '@ui/components';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';

export const AppSidebarInset = () => {
  const { open } = useSidebar();
  const isMobile = useIsMobile();

  const { setOpen } = useSidebar();

  const mainMaxWidth = useMemo(
    () =>
      isMobile
        ? '100vw'
        : open
          ? `calc(100vw - ${SIDEBAR_WIDTH}`
          : // : `calc(100vw - var(--sidebar-width-icon))`,
            '100vw',
    [open, isMobile],
  );

  return (
    <SidebarInset>
      <header className="m-4 mb-2 flex items-center gap-4">
        <SidebarTrigger
          className="size-5"
          data-testid="sidebar-trigger-btn"
        />
        <AppBreadcrumb />
      </header>
      <div
        className="flex-1 overflow-hidden p-4"
        style={{ width: mainMaxWidth }}
        onClick={() => setOpen(false)}
      >
        <Outlet />
      </div>
    </SidebarInset>
  );
};
